import { Button } from "../../button/Button";
import { appErrorActions } from "./ErrorActions.css";

/**
 * Actions buttons for the user to use after an error has occurred
 */
export function ErrorActions() {
  return (
    <div className={appErrorActions}>
      <Button onClick={() => window.location.reload()} variant="primary">
        Reload Application
      </Button>
      <Button variant="secondary" onClick={() => (window.location.href = "/")}>
        Go to Home
      </Button>
    </div>
  );
}
